import { toast } from "sonner";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const checkoutToast = (plan) =>
  toast("CHECKOUT OPENING SOON", {
    description: `Stripe checkout for the ${plan} membership is being connected. Payments activate at launch.`,
  });

export const loginToast = () =>
  toast("MEMBER LOGIN COMING SOON", {
    description:
      "Member accounts are created automatically after checkout at launch.",
  });
